import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, message } from 'antd';
import { bindActionCreators } from 'redux';

import { requestApplyOnKit } from '../../common/fetch';
import ConstantAction from '../../actions/ConstantAction';
import { APPLY_REFRESH_BLACK_ICON } from '../../config/media';
import Container from './style';

const ApplyChangesModal = ({ exchange, isOpenApplyModal, requestApplyChangesModal }) => {

    const handleClose = () => {
        requestApplyChangesModal({ isOpenApplyModal: false });
    };

    const handleApply = async () => {
        try {
            await requestApplyOnKit(exchange.id);
            message.success('Applied updates successfully');
			handleClose();
		} catch(error) {
			handleClose();
			if (error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
    };

    return (
        <div>
            <Modal
                visible={isOpenApplyModal}
                footer={null}
                onCancel={handleClose}
            >
                <Container>
                    <div className="title-wrapper">
                        <img src={APPLY_REFRESH_BLACK_ICON} alt="apply refresh icon" className="apply-icon" />
                        <div>Apply latest changes</div>
                    </div>
                    <div>
                        <div className="text-content">By applying the latest changes you will be synchronizing any changes you've made on exchange dashboard to your live exchange.</div>
                        <div className="text-content">
                            <div>This may affect assets and trading pairs.</div>
                            <div>Are you sure you want to apply all the changes?</div>
                        </div>
                    </div>
                    <div className="button-container">
                        <Button type="primary" onClick={handleClose}>No, go back</Button>
                        <div className="separator"></div>
                        <Button type="primary" onClick={handleApply}>Yes, apply changes</Button>
                    </div>
                </Container>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state) => ({
    isOpenApplyModal: state.constant.isOpenApplyModal,
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
});

const mapDispatchToProps = (dispatch) => ({
    requestApplyChangesModal: bindActionCreators(ConstantAction.requestApplyChangesModal, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplyChangesModal);
